// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../graphql/api/index';

import { gql } from 'graphql-tag';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export const ShippingCountryCountryFragmentDoc = gql`
    fragment shippingCountryCountry on Country {
  isoCode
  currency
}
    `;
export const ShippingCountryFragmentDoc = gql`
    fragment shippingCountry on ShippingCountries {
  countries {
    ...shippingCountryCountry
  }
}
    ${ShippingCountryCountryFragmentDoc}`;
export const PreInitDocument = gql`
    query preInit {
  shippingCountries {
    ...shippingCountry
  }
}
    ${ShippingCountryFragmentDoc}`;

export function usePreInitQuery(options?: Omit<Urql.UseQueryArgs<never, SchemaTypes.PreInitQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<SchemaTypes.PreInitQuery, SchemaTypes.PreInitQueryVariables | undefined>({ query: PreInitDocument, variables: undefined, ...options });
};